import React from "react";
import { Box, Container, Typography, IconButton } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const Footer = () => {
  return (
    <Box
      component="footer"
      maxWidth="lg"
      sx={{
        backgroundColor: "#3f434d",
        color: "#fff",
        py: 2,
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        mx: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Typography variant="body2">
            &copy; Copyright Alpha Company 2024
          </Typography>
          <Box>
            <IconButton color="inherit" aria-label="email support">
              <EmailIcon />
            </IconButton>
            <IconButton color="inherit" aria-label="phone support">
              <PhoneIcon />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
